import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './modules/auth';
import { LocationProvider } from './modules/location/LocationContext';
import { BookingProvider } from './modules/booking/BookingContext';
import AppLayout from './components/layout/AppLayout';
import AppRoutes from './routes';

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <LocationProvider>
            <BookingProvider>
              <AppLayout>
                <AppRoutes />
              </AppLayout>
            </BookingProvider>
          </LocationProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}